export default "__VITE_ASSET__DqDhzN0S__"